<template>
  <el-table
    ref="tableBody"
    :data="tableData"
    border
    :stripe="stripe"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    @selection-change="handleSelectionChange"
    @sort-change="sortChange"
    @header-dragend="headerDragent"
    @current-change="currentChange"
    :row-key="controller.rowKey"
    :highlight-current-row="radio"
    :height="diyHeight"
    :style="{ width: '100%' }"
    :row-style="rowStyle"
    :cell-style="{ padding: '0px' }"
  >
    <!-- :style="{minHeight:diyHeight,width: '100%'}" -->
    <el-table-column v-if="controller.selection" type="selection" align="center" width="55"
                     :fixed="isfixed"></el-table-column>
    <el-table-column v-if="controller.index" label="序号" type="index" align="center" width="55"
                     :fixed="isfixed"></el-table-column>

    <el-table-column
      v-for="(item, index) in tableNameList" :fixed="item.label == '姓名' && isfixed == 'left'"
      :key="index"
      :prop="item.prop" :label="item.label" :width="item.width || 'auto'"
      :sortable="item.sortable ? item.sortable : false"
      :align="item.align ? item.align : 'center'"
      :show-overflow-tooltip="item.overflow ? item.overflow : false"
    >
      <template slot-scope="scope">
        <innerSlot v-if="item.formatter" :scope="scope" :name="item.prop" :formatter="item.formatter"></innerSlot>
        <slot v-else :scope="scope" :name="item.prop">{{ scope.row[item.prop] }}</slot>
      </template>
    </el-table-column>

    <el-table-column v-if="controller.isActive" :fixed="fixed" label="操作" align="center"
                     :width="controller.width || 'auto'">
      <template slot-scope="scope">
        <slot :scope="scope" name="control"></slot>
        <!-- <el-button type="default" size="small">查看</el-button>
                <el-button @click="frozenAccount(scope.row)" type="primary" size="small">{{scope.row.frozen === 1 ?'冻结':'解冻'}}</el-button>
        <el-button @click="remove(scope.row)" type="danger" size="small">删除</el-button>-->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import innerSlot from './slotItem'

export default {
  components: {innerSlot},
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableNameList: {
      type: Array,
      default: () => [{align: 'center'}]
    },
    controller: {
      type: Object,
      default: function () {
        return {
          isActive: false,
          selection: false,
          width: 250,
          rowKey: ''
        }
      }
    },
    fixed: {
      type: [String, Boolean],
      default: function () {
        return 'right'
      }
    },
    diyHeight: {
      type: String,
      default: function () {
        return '400'
      }
    },
    rowStyle: {
      type: Object,
      default: function () {
        return {
          height: '60px'
        }
      }
    },
    alignText: {
      type: String,
      default: () => {
        return 'center'
      }
    },
    radio: { // 高亮
      type: Boolean,
      default: false
    },
    stripe: { // 带斑马纹
      type: Boolean,
      default: true
    },
    isfixed: {
      type: [String, Boolean],
      default: false
    }
  },
  methods: {
    sort(e) {
      console.log(e);
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    },
    sortChange(e) {
      this.$emit('sortChange', e)
    },
    clickCurrentRow(r) {
      this.$emit('clickCurrentRow', r)
    },
    currentChange(e) {
      this.$emit('currentChange', e)
    },
    toggleRowSelection(row, selected) {
      this.$refs.tableBody.toggleRowSelection(row, selected || true)
    },
    headerDragent() {
      this.$refs.tableBody.doLayout();
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/tableBody/index.vue